import { FC } from 'react';
import strings from './file.translations';
import { FileUploader } from 'react-drag-drop-files';
import { merge } from '../../utils/utility';
import { FaBoxOpen } from 'react-icons/fa';
import { Button } from '../button/Button';
import { clsx } from 'clsx';

interface DropBoxProps {
  files?: FileList;
  onChange: (newFile?: FileList) => void;
  onUpload: (files: FileList) => void;
  className?: string;
  fullWidth?: boolean;
  error?: string;
}

export const DropBox: FC<DropBoxProps> = ({ files, onChange, onUpload, className, fullWidth, error }) => {
  const classToUse = merge(
    className,
    'border-2 border-dashed border-primary-800 rounded-md',
    'text-primary-800 font-semibold text-lg text-center',
    'flex flex-col gap-2 items-center justify-center p-5'
  );

  const fileNames: string[] = [];
  if (files) {
    for (var i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        fileNames.push(file.name);
      }
    }
  }

  let fileText: string;
  const FILE_NAME_LIMIT = 4;

  if (!files || files.length === 0) {
    fileText = strings.boxMessage;
  } else if (files.length === 1) {
    fileText = files.item(0)!.name;
  } else if (files?.length < FILE_NAME_LIMIT) {
    const fileNames: string[] = [];
    for (var i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        fileNames.push(file.name);
      }
    }
    fileText = `${fileNames.slice(0, -1).join(', ')} and ${fileNames[fileNames.length - 1]}`;
  } else {
    fileText = `${files.item(0)?.name} and ${files.length - 1} others`;
  }

  return (
    <div className="space-y-2">
      <FileUploader handleChange={onChange} multiple>
        <div className={classToUse}>
          {fileText}
          <FaBoxOpen className="h-10 w-10" />
        </div>
      </FileUploader>
      {error && <div className="text-red-500">{`Error: ${error}`}</div>}
      {files && files.length > 0 && (
        <div className={clsx('flex gap-2')}>
          {!fullWidth && (
            <Button
              secondary
              onClick={event => {
                onChange(undefined);
              }}
            >
              Cancel
            </Button>
          )}
          <Button
            primary
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              onUpload(files);
            }}
            className={fullWidth ? 'flex-1' : ''}
          >
            Upload
          </Button>
        </div>
      )}
    </div>
  );
};
